<div class="row justify-content-center">
  <div class="col-6">
    <div class="row">
      <h5>{{ localizationKey('hospitalTechnicianSettingsTitle') | localize }}</h5>
    </div>

    <label class="w-100 my-2">
      <input
        type="checkbox"
        data-testid="assign-sleep-technicians"
        [ngModel]="assignSleepTechniciansEnabled"
        (ngModelChange)="onAssignSleepTechniciansChange($event)"
      />
      {{ localizationKey('hospitalTechnicianSettingsSleepTechniciansEnabledCheckbox') | localize }}
    </label>
    <div class="my-2" data-testid="ecg-workflow-radio-buttons">
      <div class="row">
        <h6>{{ localizationKey('hospitalTechnicianSettingsEcgWorkflowSectionLabel') | localize }}</h6>
      </div>

      <div class="row my-1">
        <div class="col-6">
          <input
            id="ecg-workflow-doctor-analysis-only"
            data-testid="assign-ecg-technicians"
            type="radio"
            name="ecgWorkflow"
            value="DOCTOR_ANALYSIS_ONLY"
            [ngModel]="ecgWorkflow"
            (ngModelChange)="onEcgWorkflowChange($event)">
          <label for="ecg-workflow-doctor-analysis-only" class="ms-1">
            {{ localizationKey('hospitalTechnicianSettingsEcgDoctorAnalysisOnlyRadio') | localize }}
          </label>
        </div>
      </div>
      <div class="row my-1">
        <div class="col-6">
          <input
            id="ecg-workflow-technician-analysis-only"
            data-testid="ecg-workflow-technician-analysis-only"
            type="radio"
            name="ecgWorkflow"
            value="TECHNICIAN_ANALYSIS_ONLY"
            [ngModel]="ecgWorkflow"
            (ngModelChange)="onEcgWorkflowChange($event)">
          <label for="ecg-workflow-technician-analysis-only" class="ms-1">
            {{ localizationKey('hospitalTechnicianSettingsEcgTechnicianAnalysisOnlyRadio') | localize }}
          </label>
        </div>
      </div>
      <div class="row my-1">
        <div class="col-6">
          <input
            id="ecg-workflow-technician-pre-analysis"
            data-testid="ecg-workflow-technician-pre-analysis"
            type="radio"
            name="ecgWorkflow"
            value="TECHNICIAN_PRE_ANALYSIS"
            [ngModel]="ecgWorkflow"
            (ngModelChange)="onEcgWorkflowChange($event)">
          <label for="ecg-workflow-technician-pre-analysis" class="ms-1">
            {{ localizationKey('hospitalTechnicianSettingsEcgTechnicianPreAnalysisRadio') | localize }}
          </label>
        </div>
      </div>
    </div>
  </div>

</div>
